<script>
export const group = 'Full'
</script>

<script setup>
import VideoPlayer from '../../VideoPlayer.vue'
import NextPlaying from './NextPlaying.vue'

defineProps({
  item: Object,
})
</script>

<template>
  <div class="size-full text-white">
    <NextPlaying v-if="item.enrichment.track?.next" :key="item.id" :item="item" />
    <VideoPlayer class="object-contain object-left" :src="item.properties.fallbackVideo" autoplay muted />
  </div>
</template>
